module.exports = __webpack_public_path__ + "img/Grafico-Sellar-trato.5fcb51aa.png";